import { isServer } from "@/utils/helpers";

export function endLoadingState() {
  if (!isServer()) {
    const loadingElement = document.querySelector("#loading-page");

    if (loadingElement) {
      loadingElement.classList.remove("show");
    }
  }
}
export function registerLoadingState() {
  if (!isServer()) {
    const loadingElement = document.querySelector("#loading-page");

    if (loadingElement && !loadingElement.classList.contains("show")) {
      loadingElement.classList.add("show");
    }
  }
}
